<ng-container *transloco="let t">
  <div fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
    <button
      mat-raised-button
      color="accent"
      *ngIf="membership?.coupon"
      [routerLink]="['/', 'membership']"
      queryParamsHandling="merge"
      fxHide.lt-md
    >
      {{
        t('app.toolbar.balance', {
          balance: membership?.balance | currency: 'EUR'
        })
      }}
    </button>

    <a
      mat-raised-button
      href="{{ t('app.toolbar.help_url') }}"
      target="_blank"
      class="help-button"
      fxHide.lt-md
    >
      {{ t('app.toolbar.help_msg') }}
    </a>
    <a
      mat-icon-button
      href="{{ t('app.toolbar.help_url') }}"
      class="help-button"
      target="_blank"
      fxHide.gt-sm
    >
      <mat-icon>help_outline</mat-icon>
    </a>

    <a
      mat-raised-button
      [routerLink]="['auth/register']"
      [routerLinkActive]="['hidden']"
      *ngIf="!user"
      color="accent"
      fxHide.lt-md
    >
      {{ t('app.user.register') }}
    </a>
    <a
      mat-icon-button
      [routerLink]="['auth/register']"
      [routerLinkActive]="['hidden']"
      *ngIf="!user"
      fxHide.gt-sm
    >
      <mat-icon>login</mat-icon>
    </a>

    <button mat-button [matMenuTriggerFor]="menu">
      <div class="menu-button">
        <span fxHide.lt-md>{{ t('app.toolbar.menu') }}</span>
        <mat-icon class="menu-icon">menu</mat-icon>
      </div>
    </button>
  </div>

  <mat-menu #menu="matMenu">
    <ng-container *ngIf="!user; else userInfo">
      <div
        mat-menu-item
        [disableRipple]="true"
        fxLayout
        fxLayoutAlign="space-evenly center"
        class="lang-select"
      >
        <shared-language-select
          [available]="availableLangs"
          [selected]="currentLang"
          (selectionChanged)="changeLang.emit($event)"
        ></shared-language-select>
      </div>

      <button
        mat-menu-item
        color="secondary"
        [routerLink]="['auth']"
        [routerLinkActive]="['hidden']"
        queryParamsHandling="merge"
      >
        {{ t('app.user.login') }}
      </button>
    </ng-container>

    <ng-template #userInfo>
      <small>{{ t('app.user.logged-in-as') }}</small>

      <div mat-menu-item>
        <mat-icon>person</mat-icon>
        <span>{{ whoAmI?.email }}</span>
      </div>

      <button
        mat-menu-item
        *ngIf="membership?.coupon"
        [routerLink]="['/', 'membership']"
        queryParamsHandling="merge"
      >
        <mat-icon>info</mat-icon>
        <span>{{ t('app.membership.title') }}</span>
      </button>

      <button
        mat-menu-item
        [routerLink]="['/', 'guest-notes']"
        queryParamsHandling="merge"
      >
        <mat-icon>sticky_note_2</mat-icon>
        <span>{{ t('app.guest-notes.title') }}</span>
      </button>

      <button
        mat-menu-item
        [routerLink]="['/', 'room-prices']"
        queryParamsHandling="merge"
      >
        <mat-icon>room_preferences</mat-icon>
        <span>{{ t('app.room-prices.title') }}</span>
      </button>

      <button
        mat-menu-item
        [routerLink]="['/', 'surcharges']"
        queryParamsHandling="merge"
      >
        <mat-icon>payments</mat-icon>
        <span>{{ t('app.surcharges.title') }}</span>
      </button>

      <button
        mat-menu-item
        [routerLink]="['/', 'signatures']"
        queryParamsHandling="merge"
      >
        <mat-icon>code</mat-icon>
        <span>{{ t('app.signatures.title') }}</span>
      </button>

      <button mat-menu-item *ngIf="user" (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ t('app.user.logout') }}</span>
      </button>
    </ng-template>
  </mat-menu>
</ng-container>
